<template>
  <div v-show="isBusy" class="loading-overlay">
    <progress class="progress" />
    <div v-if="busyMessage" class="message">{{ busyMessage }}</div>
  </div>
</template>

<script setup>
defineProps({isBusy: {default: false}, busyMessage: {default: ""}});
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(2px);
  pointer-events: auto;
  z-index: 10;
}
.progress {
  width: 140px;
  height: 10px;
}
.message {
  font-size: 0.95rem;
  margin-top: 0.5rem;
}
</style>
